import { Component, forwardRef, Input, ViewChild } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR, NgForm } from '@angular/forms';
import { ProjektstatusSelection } from '../../../core/gwr-api';
import { CapFormRowDirective } from '../../form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../form-control/form-control.component';
import { MetaDisablerDirective } from '../../directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../directives/meta-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { keysToTranslate } from '../../../../i18n/keys-to-translate';

@Component({
  selector: 'cap-projektstatus',
  templateUrl: './projektstatus.component.html',
  styleUrls: ['./projektstatus.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ProjektstatusComponent), multi: true }],
  imports: [CapFormRowDirective, CapFormControlComponent, FormsModule, MetaDisablerDirective, MetaValidatorDirective, TranslatePipe]
})
export class ProjektstatusComponent {
  @ViewChild(NgForm, { static: false })
  form: NgForm;

  @Input() heading = 'Projektstatus';

  model: ProjektstatusSelection;
  propagateChange: (id: string) => void;

  propagateTouch: (_) => void;

  constructor() {
    keysToTranslate<string>([
      'BaugesuchAbgelehnt',
      'BaugesuchBeantragt',
      'BaugesuchBewilligt',
      'ProjektAbgeschlossen',
      'ProjektBaubegonnen',
      'ProjektNichtRealisiert',
      'ProjektSistiert',
      'ProjektZurueckgezogen'
    ]);
  }

  writeValue(obj: any): void {
    this.model = obj;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }

  selectAll() {
    if (this.model.sucheAlle.valueOf()) {
      this.model.sucheAnnulliert = false;
      this.model.sucheBeantragt = false;
      this.model.sucheBewilligt = false;
      this.model.sucheBaubegonnen = false;
      this.model.sucheAbgeschlossen = false;
      this.model.sucheSistiert = false;
      this.model.sucheAbgelehnt = false;
      this.model.sucheNichtRealisiert = false;
      this.model.sucheZurueckgezogen = false;
    } else {
      this.model.sucheAnnulliert = true;
      this.model.sucheBeantragt = true;
      this.model.sucheBewilligt = true;
      this.model.sucheBaubegonnen = true;
      this.model.sucheAbgeschlossen = true;
      this.model.sucheSistiert = true;
      this.model.sucheAbgelehnt = true;
      this.model.sucheNichtRealisiert = true;
      this.model.sucheZurueckgezogen = true;
    }
  }

  selectOne(event) {
    if (
      this.model.sucheAnnulliert &&
      this.model.sucheBeantragt &&
      this.model.sucheBewilligt &&
      this.model.sucheBaubegonnen &&
      this.model.sucheAbgeschlossen &&
      this.model.sucheSistiert &&
      this.model.sucheAbgelehnt &&
      this.model.sucheNichtRealisiert &&
      this.model.sucheZurueckgezogen
    ) {
      this.model.sucheAlle = true;
      this.selectAll();
      event.target.checked = false;
    } else {
      this.model.sucheAlle = false;
    }
  }
}
